export const OPPORTUNITIES_PAGE_KEY = "opportunities_creator";

// Keep in sync with web_admin/src/views/pages/PageBuilder/sectionSchemas.js.
// Empty fonts mean "keep the site fonts", so nothing changes until an admin picks one.
export const DEFAULT_OPPORTUNITIES_LAYOUT = {
  theme: {
    headingFont: "",
    bodyFont: "",
    primaryColor: "#FF7F26",
  },
  sections: [
    {
      id: "hero",
      type: "opportunitiesHero",
      visible: true,
      style: {},
      props: {
        eyebrow: "Opportunities",
        heading: "More than a job board",
        subtext:
          "Full-time roles, two-day gigs, voice-over assignments, auditions, grants and collaborations. Find the creative opportunity that fits where you are right now.",
        searchPlaceholder: "Search by title, skill or keyword",
      },
    },
    {
      id: "filters",
      type: "opportunitiesFilters",
      visible: true,
      style: {},
      props: {
        allTypesLabel: "All opportunities",
        disciplinePlaceholder: "All disciplines",
        locationPlaceholder: "Location",
        remoteLabel: "Remote only",
      },
    },
    {
      id: "results",
      type: "opportunitiesResults",
      visible: true,
      style: {},
      props: {
        viewDetailsLabel: "View details",
        emptyText:
          "New opportunities are posted regularly. Create your profile so organisations can find you in the meantime.",
        createProfileButton: "Create your free profile",
        browseTalentButton: "Browse creative talent",
      },
    },
  ],
};
